import { gql } from '@apollo/client'

export default gql(`
    mutation($title: String! $project: String) {
        createMetaSection(
            input: {
                title:$title
                project:$project
            }
        ) {
            id
            title
            usedCount
        }
    }`
)
